import { Box, TextField, Typography } from "@mui/material";
import SubmitButton from "../../../UI/SubmitButton";
import EntryButton from "../../../UI/EntryButton";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "../../../store/modalSlice";
import { useTranslation } from "react-i18next";
import { createCategoryAction } from "../../../asyncActions/productAction";
import { branchToogleArchiveAction } from "../../../asyncActions/branchActions";

function BranchArchiveContent() {
    const { t } = useTranslation()

    const dispatch = useDispatch()

    const {
        data
    } = useSelector(store => store.modal)

    const {isArchived, branchId} = data

    const submitHandle = async () => {
        const modalPayload = {
            active: true,
            content: 'action',
            data: {
                text: 'Branch was changed!',
                path: '/branches'
            }
        }
        dispatch(branchToogleArchiveAction(branchId))
        dispatch(setModal(modalPayload))
    }

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '15px',
            width: '450px'
        }}>
            <Typography variant="h6">Did u want to{isArchived ? 'activate' : 'archive'} branch?</Typography>
            <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                <EntryButton type='button' onClick={() => dispatch(setModal({ active: false }))}>{t('button.cancel')}</EntryButton>
                <SubmitButton onClick={submitHandle} type='submit'>{t('button.submit')}</SubmitButton>
            </Box>

        </Box>
    )
}


export default BranchArchiveContent
